import React from 'react';
import { LoginCard, PageContainer, RegistrationForm, StyledInput,FieldTitleNew, Button } from './style';
import { ImageUrl } from '../../utils/constants';
import {Divider} from '../../components/Manager/styles';

function CompanyDescription() {
  return (
    <PageContainer
      style={{
        backgroundImage: `url(${ImageUrl}/plg/company_form.png)`,
        // backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      <div className="content">
        <LoginCard isFontSize={"24px"} isLineHeight={"36px"}>
          <div className="formHeading">Hi [User name]!</div> 
          <div className="formHeading">About your company</div> 
          <RegistrationForm>
            <FieldTitleNew marginBottom={"12px"}> Company name</FieldTitleNew>
            <StyledInput marginBottom type="text" placeholder='Enter company name' name='fname' 
              // value={details.fname} onChange={(e) => this.onChangeInput(e, index)
            />
            <FieldTitleNew marginBottom={"12px"}>Set company password</FieldTitleNew>
            <StyledInput marginBottom type="password" placeholder='Enter company password' name='password' 
              // value={details.fname} onChange={(e) => this.onChangeInput(e, index)
            />
           
            <Divider isMargin={"20px 0px"}/>
            <Button>Next</Button>

          </RegistrationForm>
        </LoginCard>
      </div>
      <footer className="footer">
        <div className="termText">Terms of Use Contact Us</div>
        <div className="copyrightText"> © 2025 Training Amigo LLC. All Rights Reserved</div>
      </footer>
    </PageContainer>
  );
}

export default CompanyDescription;
